import getIP from "getIP";
import urlConfig from "./urlConfig";

// Maps pathname fragments to urlConfig keys (order matters — more specific paths first)
const PATH_MAP = [
  ["/insights/reports",                   "usageReports"],
  ["/insights/usage-reports",             "reportsPA"],
  ["/insights/dashboard",                 "insightsDashboard"],  // handled separately below
  ["/app/home",                           "homePage"],
  ["/sms/Register/sender-addresses",      "smsSenderAddress"],
  ["/sms/sender-address-specifications",  "smsSenderAddress"],
  ["/sms/manage-templates",               "smsTemplates"],
  ["/sms/my-campaigns",                   "smsCampaigns"],
  ["/sms/smpp-session",                   "smppSession"],
  ["/voice/campaign",                     "voiceCampaign"],
  ["/voice/file-manager",                 "voiceFileManager"],
  ["/whatsapp/getting-started",           "whatsappProfile"],
  ["/whatsapp/profiles-info",             "whatsappProfile"],
  ["/whatsapp/templates",                 "whatsappTemplates"],
  ["/whatsapp/my-campaigns",              "whatsAppCampaign"],
  ["/studio/editor",                      "studioEditor"],
  ["/studio/dashboard/myFlows",           "studioDashboard"],
  ["/myplans/packages",                   "packages"],
  ["/myplans/ratesheets",                 "ratesheets"],
  ["/user-management/roles",              "roles"],
  ["/user-management/users",              "users"],
  ["/contacts/distribution-list",         "distributionList"],
  ["/contacts/contact-list",              "contactList"],
  ["/contacts/contact-group",             "contactGroup"],
  ["/segmentation",                       "segmentation"],
  ["/Logs/Activity",                      "logsActivity"],
  ["/Logs/Debug",                         "logsDebug"],
  ["/Logs/Enterprise",                    "logsEnterprise"],
  ["/notification_PA",                    "notificationPA"],
  ["/notification",                       "notification"],
  ["/NumbersEA",                          "numbersEA"],
  ["/NumbersPA",                          "numbersPA"],
  ["/billing-pricing/rate-sheets",        "rateSheetPA"],
  ["/billing-pricing/packages",           "packagesPA"],
  ["/billing-pricing/wallets",            "walletsPA"],
  ["/billing-pricing/invoicing",          "invoicingPA"],
  ["/accounts",                           "accountsPA"],
  ["/email/my-campaigns",                 "emailCampaigns"],
  ["/email/email-templates",              "emailTemplates"],
  ["/email/Register/email-addresses",     "emailAddressEA"],
  ["/email/email-address-specifications", "emailAddressPA"],
  ["/Providers",                          "providersPA"],
  ["/Routing",                            "routersPA"],
  ["/policy/QuietTime",                   "quietTime"],
  ["/policy/contentfilter",               "contentFilter"],
  ["/policy/blacklist/msisdn",            "blacklist"],
  ["/policy/dnd/msisdn",                  "dnd"],
  ["/header/change-profile",                  "changeProfile"],
  ["/header/billing",                  "billing"],
  ["/authconfig",                  "authConfig"],
  ["/developer/api-keys",                  "apiKeys"],
];

// Role to base-path segment mapping
const ROLE_BASE = {
  PA: "Admin",
  EU: "User",
  EA: "Account",
};

export const handleHelpClick = (pathname, loggedInRole) => {
  let { origin } = window.location;

  if(origin==='http://localhost:3000') {
    origin = getIP();
  }
  const buildUrl = (path, role) => {
    if (!path) return "";
    // Studio paths are full paths (start with /docs), just prepend origin
    if (path.startsWith("/docs")) return `${origin}${path}`;
    // Standard pattern: /{Role}/index.htm#t={path}
    return `${origin}/${ROLE_BASE[role]}/index.htm#t=${path}`;
  };

  // Dashboard needs special handling for channel-based sub-keys
  if (pathname.startsWith("/app/insights/dashboard")) {
    let channel = window?.history?.state?.channel ?? "All";
    if (channel === "All Channels") channel = "All";
    const url = buildUrl(urlConfig.insightsDashboard[`${channel}_${loggedInRole}`], loggedInRole);
    if (url) window.open(url, "_blank");
    return;
  }

  const match = PATH_MAP.find(([fragment]) => pathname.startsWith('/app'+fragment));
  if (!match) return;

  if (pathname.startsWith("/app/header/billing") && urlConfig[match[1]]) {
    let tab = window?.history?.state?.tab ?? "_Billing_Info";
    const url = buildUrl(urlConfig[match[1]]?.[`${tab}_${loggedInRole}`], loggedInRole);
    if (url) window.open(url, "_blank");
    return;
  }


  const url = buildUrl(urlConfig[match[1]]?.[loggedInRole], loggedInRole);
  if (url) window.open(url, "_blank");
};
